<!-- nav並び順設定 -->
<template>
  <transition name="slideNavSettingMenu" v-on:enter="enter">
    <div
      v-if="showSettingMenu"
      class="crly-m-contents-setting"
      @touchmove.prevent=""
    >
      <div class="crly-m-contents-setting__close-area" @click="clickClose">
        <div></div>
      </div>
      <div class="drawer-menu" @touchmove.stop="">
        <div class="crly-m-contents-setting__header">
          <h2 class="crly-m-contents-setting__header__item left">
            {{ $t("headerNav.sort.title") }}
          </h2>
          <div class="crly-m-contents-setting__header__item right">
            <CrlyAtomsContentsCompleteBtn
              @clickCompleteBtn="clickCompleteBtn"
            />
          </div>
        </div>
        <ul class="crly-m-contents-setting__main list-group drag">
          <draggable
            :list="currentList"
            class="dragArea"
            :options="{ animation: 300, handle: '.handle' }"
          >
            <template v-for="item in currentList">
              <CrlyAtomsContentsSortItem :key="item.class" :item="item" />
            </template>
          </draggable>
        </ul>
      </div>
    </div>
  </transition>
</template>

<script>
import CrlyAtomsContentsCompleteBtn from "@crly/components/atoms/contents/CompleteBtn.vue";
import CrlyAtomsContentsSortItem from "@crly/components/atoms/contents/SortItem.vue";

import draggable from "vuedraggable";

export default {
  name: "CrlyMoleculesContentsSettingMenu",
  components: {
    CrlyAtomsContentsCompleteBtn,
    CrlyAtomsContentsSortItem,
    draggable
  },
  props: {
    showSettingMenu: {
      type: Boolean,
      default: false
    },
    showMenu: {
      type: Boolean,
      default: true
    },
    itemList: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    currentList: []
  }),
  methods: {
    enter() {
      this.currentList = this.itemList.concat();
    },
    /**
     * 完了ボタンクリックイベント
     */
    clickCompleteBtn() {
      this.$emit("clickCompleteBtn", this.currentList);
    },
    /**
     * 閉じる「×」ボタンクリックイベント
     */
    clickClose() {
      this.$emit("clickNavSettingCloseBtn");
    }    
  }
};
</script>

<style lang="scss" scoped>
@import "@crly/assets/css/molecules/contents/settingMenu.scss";
</style>
